/* eslint-disable prettier/prettier */
module.exports = {
  sanity: {
    projectId: "lfzk1swo",
    dataset: "production",
  },
};
